module.exports = __webpack_public_path__ + "static/media/map.ce1bd606.svg";